import { call, put, fork, takeLatest } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';

import * as types from 'constants/ActionTypes';

import * as variantActions from '../actions/variantActions';

// GET SPECIFIC VARIANT
function* fetchVariant({ payload, meta }) {
  const { modelId, derivativeCode, variantCode, ...metaRest } = meta;
  const { request } = payload;
  const { params } = request;

  try {
    const response = yield call(restClient.request, request);
    yield put(variantActions.fetchVariantSuccess(response.data, modelId, derivativeCode, variantCode));
    yield put(variantActions.fetchVariantMutex({ modelId, derivativeCode, variantCode, params }, metaRest));
  } catch (e) {
    yield put(variantActions.fetchVariantFailure(e));
  }
}

// GET SPECIFIC VARIANT MUTUAL EXCLUSIONS FOR OPTIONS
function* fetchVariantMutex({ payload, meta }) {
  const { request } = payload;
  const { variantCode } = meta;

  try {
    const response = yield call(restClient.request, request);
    yield put(variantActions.fetchVariantMutexSuccess(response.data, variantCode));
  } catch (e) {
    yield put(variantActions.fetchVariantMutexFailure(e));
  }
}

function* fetchVariantWatcher() {
  yield takeLatest(types.FETCH_VARIANT_REQUEST, fetchVariant);
  yield takeLatest(types.FETCH_VARIANT_MUTEX_REQUEST, fetchVariantMutex);
}

const variantSagas = [fork(fetchVariantWatcher)];

export default variantSagas;
